import Pen from '../../src/legacy/Pen.tsx';
export default Pen;
